export const SET_ALL_ANNOUNCEMENT = 'SET_ALL_ANNOUNCEMENT';
export const SET_ANNOUNCEMENT = 'SET_ANNOUNCEMENT';
export const SET_ALL_TAG = 'SET_ALL_TAG';
export const SET_ALL_TEMPLATE = 'SET_ALL_TEMPLATE';
